export type DiscordUser = {
    username: string;
    discriminator: string;
    id: string;
    bot: boolean;
    flags: number;
    avatar?: string | null | undefined;
    global_name?: string | null | undefined;
    avatar_decoration_data?: {
        asset: string;
        skuId?: string | undefined;
    } | null | undefined;
    premium_type?: number | null | undefined;
    nickname?: string | undefined;
};

export type SessionDetails = {
    status: string;
    roomid: string;
    code: string;
    userId: string;
    at: string;
}
export enum LoadStatus{
    IDLE,
    REQUESTING_ROOM,
    ERROR_SPROOM,
    WAITING_FOR_MEDIA,
    STREAMING,
    ERROR
}